/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

// import required modules
import { A11y, Pagination } from "swiper";

import Image from "next/image";
import IsRtl from "components/Shared/isRtl";
import { RichText } from "@sitecore-jss/sitecore-jss-nextjs";
import { DGACarouselArrow } from "components/Shared/dga-carousel-arrow/DGACarouselArrow";

export const InitiativeThreeColsLgCardsSwiper = (props: any) => {
  const [swiper, setSwiper] = useState<any>();
  const [isEnd, setIsEnd] = useState(false);
  const [isBeginning, setIsBeginning] = useState(false);
  const handleSwiperUpdate = (swiper: any) => {
    setSwiper(swiper);
    // check if at end or at beginneg
    swiper.on("slideChange", () => {
      if (swiper.isEnd) {
        setIsEnd(true);
      } else {
        setIsEnd(false);
      }
      if (swiper.isBeginning) {
        setIsBeginning(true);
      } else {
        setIsBeginning(false);
      }
    });
  };

  const componentId = `${props?.SectionId}-${props?.sectionIx}`.trim().replace(/ /g, "-");
  useEffect(() => {
    if (swiper) {
      setIsBeginning(swiper.isBeginning);
      setIsEnd(swiper.isEnd);

      // Optional: attach listener once only
      swiper.on("slideChange", () => {
        setIsBeginning(swiper.isBeginning);
        setIsEnd(swiper.isEnd);
      });
    }
  }, [swiper]);
  return (
    <div id={props?.SectionId} className="py-10 flex flex-col gap-8">
      {(props?.fields?.Title?.value || props?.fields?.Description?.value) && (
        <div className="responsive flex flex-col gap-8">
          {props?.fields?.Title?.value && (
            <p className="animate-top-dga text-3xl font-bold">{props?.fields?.Title?.value}</p>
          )}
          {props?.fields?.Description?.value && (
            <div className="animate-top-dga overflow-hidden text-base font-normal">
              <RichText field={props?.fields?.Description} />
            </div>
          )}
        </div>
      )}
      {props?.fields?.Items && props?.fields?.Items?.length > 0 && (
        <div
          className={`${swiper ? "opacity-100" : "opacity-0"} transition-opacity duration-500 ${
            IsRtl() ? "mr-[5%] " : "ml-[5%] "
          } md:responsive pt-10`}
        >
          <Swiper
            onInit={(ev) => {
              setSwiper(ev as any);
              if (ev.isEnd) {
                setIsEnd(true);
              } else {
                setIsEnd(false);
              }
              if (ev.isBeginning) {
                setIsBeginning(true);
              } else {
                setIsBeginning(false);
              }
            }}
            onSwiper={(e) => {
              handleSwiperUpdate(e);
              // check end and beginner
            }}
            slidesPerView={1.2}
            spaceBetween={16}
            breakpoints={{
              768: {
                slidesPerView: 2,
                spaceBetween: 24,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 24,
              },
            }}
            pagination={{ clickable: true, el: `#${componentId}` }}
            freeMode={true}
            modules={[Pagination, A11y]}
            a11y={{
              enabled: true,
              paginationBulletMessage: "Go to slide {{index}}",
            }}
            dir={IsRtl() ? "rtl" : "ltr"}
            className="mySwiper !p-[1px]"
          >
            {props?.fields?.Items?.length > 0 &&
              props?.fields?.Items?.map((card: any, index: number) => {
                return (
                  <SwiperSlide className="w-full !text-start !h-auto overflow-hidden" key={index}>
                    <div className=" animate-top-dga w-full border border-neutral-300 rounded-2xl h-full p-4 flex bg-white flex-col gap-5 items-center">
                      {card?.fields?.Icon?.value?.src && (
                        <div className="h-[48px] bg-neutral-100 rounded-full relative w-[48px] mx-auto">
                          <Image
                            unoptimized
                            src={card?.fields?.Icon?.value?.src}
                            alt={(card?.fields?.Icon?.value?.alt ?? "").trim() || (card?.fields?.Title?.value ?? "").trim() || "Initiative icon"}
                            layout="fill"
                            objectFit="contain"
                          />
                        </div>
                      )}
                      {card?.fields?.Title?.value && (
                        <p className="text-lg font-bold">{card?.fields?.Title?.value}</p>
                      )}
                      {card?.fields?.Description?.value && (
                        <RichText
                          id={"section-point-" + props?.SectionId + "-" + index}
                          className=""
                          field={card?.fields?.Description}
                        />
                      )}
                    </div>
                  </SwiperSlide>
                );
              })}
          </Swiper>
          <div id={componentId} className="md:hidden custom_swiper !mt-8 mx-auto !justify-center" />
          {props?.fields?.Items?.length > 1 && (
            <div
              className={`
        ${swiper ? "opacity-100" : "opacity-0"}
        w-fit
        ${IsRtl() ? "mr-auto" : "ml-auto"}
        flex-row gap-4 mt-8
        ${props?.fields?.Items?.length > 1 ? "hidden" : "hidden"}
        ${props?.fields?.Items?.length > 2 ? "md:flex" : "md:hidden"}
        ${props?.fields?.Items?.length > 3 ? "lg:flex" : "lg:hidden"}
      `}
            >
              <DGACarouselArrow
                direction={IsRtl() ? "right" : "left"}
                onClick={() => {
                  swiper?.slidePrev();
                  handleSwiperUpdate(swiper);
                }}
                size={"large"}
                disabled={isBeginning}
                style={"primary"}
              />
              <DGACarouselArrow
                direction={IsRtl() ? "left" : "right"}
                onClick={() => {
                  swiper?.slideNext();
                  handleSwiperUpdate(swiper);
                }}
                size={"large"}
                disabled={isEnd}
                style={"primary"}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
